import clsx from "clsx";
import React, { Fragment, useContext } from "react";
import styled from "@emotion/styled/macro";
import { DetailsListColumn } from "./types";
import { ResizeContext } from "./ResizeContextProvider";

type Props = {
  column: DetailsListColumn;
  columnIndex: number;
};

export const ResizeHandle = ({ column, columnIndex }: Props) => {
  const [{ column: resizedColumn }, dispatch] = useContext(ResizeContext);
  const isDragging = resizedColumn && resizedColumn.key === column.key;

  return (
    <Fragment>
      <Resizer
        onClick={e => e.stopPropagation()}
        className={clsx({ isDragging })}
        onMouseDown={e => {
          dispatch({
            type: "START_RESIZE",
            payload: {
              column,
              columnIndex,
              mouseX: e.clientX
            }
          });
        }}
      >
        <Line />
      </Resizer>
    </Fragment>
  );
};

export const Line = styled.div`
  width: 2px;
  height: 100%;
`;

export const Resizer = styled.div`
  width: 16px;
  height: 100%;
  z-index: 2;
  cursor: col-resize;
  display: flex;
  justify-content: center;
  position: absolute;
  right: -8px;
  &:hover {
    ${Line} {
      background-color: #005aa1;
    }
  }
  &.isDragging {
    ${Line} {
      visibility: hidden;
    }
  }
`;
